/**
 * CPV Q6-P6 · the validation pack's door to the server (`/bp/cpv/validation-pack/…`, QA only).
 *
 *   access()     GET …/access/     → {allowed, policy}: may the person read the pack at a plant in view
 *   summary()    GET …/            → the pack in brief: requirements, those without automated tests, documents, OQ scripts
 *   download()   GET …/download/   → the pack generated now, saved as the server's ZIP file name
 *
 * The client decides nothing: who may read it and every number shown are the server's.
 */
import { get } from '../cpvMasterApi';
import { download } from '../cpvHistoryApi';

const BASE = '/cpv/validation-pack';

export const validationPackApi = {
  access: () => get(`${BASE}/access/`),
  summary: () => get(`${BASE}/`),
  download: () => download(`${BASE}/download/`, undefined, 'cpv-validation-pack.zip'),
};
